import { Injectable } from '@angular/core';
import { CmsService } from '../cms.service';

import { Resolve } from '@angular/router';

import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class HomeResolver implements Resolve<any> {
  constructor(private cms: CmsService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.cms.getHome();
  }
}


// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/home/home.resolver.ts